enum LanguagesAvailable {
  // Right now added only one language to enable test in beta.
  // This Enum will be moved to a separate package which will be shared with clients
  en_US = 'en-US',
}

export default LanguagesAvailable;
